
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Person } from '../../../utils/types';
import { useParams } from 'react-router-dom';
import Pagination from '../../../components/Pagination';
import PersonList from './personList';
import { getPersonsAllList } from '../../../utils/apicall/personsApi';
import { CONFIG } from '../../../utils/config';
import { useLocation, useNavigate } from "react-router-dom";
import { authService } from '../../../utils/authServices';




const PersonDashBoard: React.FC  = ( ) => {
    const [data, setData] = useState<Person[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>(''); // State for the search input
    const [currentPage, setCurrentPage] = useState(1);
    const itemPerPage = 15;
    const location = useLocation();
    const navigate = useNavigate();
    
    const loadData = useCallback(async () => {
      try {
       const response = await getPersonsAllList();
        
        if (response ) {
          setData(response);
         // console.log("response: ", response);
        } else {
          console.warn('Expected an array but got:', response);
        }
      } catch (error) {
        console.error('An error occurred while fetching data.', error);
      }
  
    }, []);

    useEffect(() => {
   //   console.log("before");
   //   console.log("location.state?.refresh", location.state?.refresh);
      if (location.state?.refresh) {
    //    console.log("Refresh triggered");
        // Call your refresh logic here (e.g., reload data or update UI)
        loadData();
        authService.refreshAuthToken();
        // Optional: Reset the state to prevent repeated refresh
        location.state.refresh = false; // This won't persist, as `location.state` is ephemeral.
      }
    }, [location.state]); 
  
    useEffect(() => {
      loadData();
      authService.refreshAuthToken();
    }, [loadData]);
  
// Apply search filter
const filteredData = useMemo(() => {
  return data.filter(item => {
    const firstNameMatch = item.firstName && item.firstName.toLowerCase().includes(searchTerm.toLowerCase());
    const lastNameMatch = item.lastName && item.lastName.toLowerCase().includes(searchTerm.toLowerCase());
    return firstNameMatch || lastNameMatch;
  });
}, [data, searchTerm]);
  
   
    // Handle page change
    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };
  
    // Handle search input change
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(event.target.value);
    };
  
    const handleAddClick = ()  => {
      navigate(CONFIG.urls.getPersonsAddUrl_Admin(), {
        state: { returnTo: CONFIG.urls.getPersonsUrl_Admin() },
      });
    };
  
    const totalPages = Math.ceil(filteredData.length / itemPerPage);
  
  
    return (
      <div className="content">
           <section className="ontotita py-5">
           <div className="container">
              <div className="row align-items-center">
                <div className="col-md-7">
                    <h2 className="h4 text-primary fw-light py-3">Κατάλογος Προσωπικού Φορέα</h2>
                </div>
             </div>
          {/* Search and Sort Controls */}
          <div className="row align-items-center">
            {/* <!-- Search Input --> */}
            <div className="col-md-9 mb-4">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Αναζήτηση ..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
             </div>
              {/* <!-- Button aligned right -->*/}
              <div className="col-md-3 mb-4 text-md-end">
              <button className="btn btn-success btn-sm"  onClick={() => handleAddClick()}>
                  <i className="bi bi-plus me-1"></i> Προσθήκη
                  </button>
               {/*   <a href={CONFIG.urls.getPersonsAddUrl_Admin()} className="btn btn-success btn-sm"><i className="bi bi-plus me-1"></i> Προσθήκη</a>*/}
              </div>
             
          </div>

             <div className="row">
                <div className="col-12">
                   <hr className="" style={{ borderColor: "#036EC5" }} />
                </div>
            </div>
           
           
      
      
          <div id="projectList">
            <PersonList data={filteredData.slice((currentPage - 1) * itemPerPage, currentPage * itemPerPage)} fromid={'-2'}/>
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
          </div>
      
          </div>
      </section>

      </div>
    );
  };

export default PersonDashBoard;
